import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentTrials } from '../services/get-current-trials.service';
import { RequestStatus } from '../interface';
import { selectCurrentTrialsState } from '../selectors';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
import { DataFetchingError } from '../errors/DataFetchingError';
export const getCurrentTrialsThunk = createAsyncThunk('getCurrentTrials', async (portalId, {
  rejectWithValue
}) => {
  // Skipping fetching current trials if portalId is not provided (hubless)
  if (!portalId) {
    return [];
  }
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  try {
    return await getCurrentTrials(portalId);
  } catch (error) {
    const requestError = error;
    logger.error(new DataFetchingError('Failed to fetch current trials', {
      statusCode: requestError.status,
      cause: requestError
    }));
    return rejectWithValue([]);
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectCurrentTrialsState(state);
    return status === RequestStatus.IDLE;
  }
});